module.exports = __webpack_public_path__ + "static/media/hue-mac.6852695f.jpg";